import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

const bodyWrapperStyles = xcss({
	flexGrow: '1',
});

type SidePanelBodyProps = {
	children: React.ReactNode;
};

export const SidePanelBody = ({ children }: SidePanelBodyProps) => {
	return <Box xcss={bodyWrapperStyles}>{children}</Box>;
};
